import { Component, Input, OnChanges } from '@angular/core';
import { OffboardingDateProposal, OffboardingHistory } from '../../models/offboarding.model';
import { workflowTrackBy } from '../common/employee-assets/asset.helpers';
import { ASSET } from '../common/employee-assets/asset.constants';

const LABEL = {before: 'OFFBOARD_PROPOSAL_BEFORE', after: 'OFFBOARD_PROPOSAL_AFTER'};

@Component({selector: 'app-offboarding-history-event', templateUrl: './offboarding-history-event.component.html',
  styleUrls: ['../common/employee-assets/employee-assets.component.css', './offboarding-history-event.component.css']})
export class OffboardingHistoryEventComponent implements OnChanges {
  @Input() event: OffboardingHistory;
  @Input() actorNames: {[id: string]: string} = {};
  proposals: {label: string; value: OffboardingDateProposal; author: string; approver: string}[] = [];
  trackBy = workflowTrackBy;
  get datesChanged(): boolean {
    const event = this.event;
    return !!event && ((event.previousTerminationDate || ASSET.empty) !== (event.terminationDate || ASSET.empty)
      || (event.previousCutoffAt || ASSET.empty) !== (event.cutoffAt || ASSET.empty)
      || !!(event.previousCutoffAt || event.cutoffAt) && (event.previousTimeZone || ASSET.empty) !== (event.timeZone || ASSET.empty));
  }
  ngOnChanges(): void {
    this.proposals = [];
    if (!this.event) { return; }
    this.addProposal(LABEL.before, this.event.proposalBefore);
    this.addProposal(LABEL.after, this.event.proposalAfter);
  }
  private addProposal(label: string, value: OffboardingDateProposal): void {
    if (!value) { return; }
    const names = this.actorNames || {};
    this.proposals.push({label, value, author: names[value.proposedBy] || value.proposedBy,
      approver: names[value.hrApprovedBy] || value.hrApprovedBy});
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-history-event.component.ts